import config from '@lyearn/academy-app/src/config';

export const languagesMap = [
  {
    value: 'en',
    label: 'Lygo:AdvancedMenu.video.Subtitles.Country.USA.label',
    languageLabel: 'English',
    flag: `${config.cdn_domain}/assets/images/flags/us.svg`,
  },
  {
    value: 'es',
    label: 'Lygo:AdvancedMenu.video.Subtitles.Country.Spain.label',
    languageLabel: 'española',
    flag: `${config.cdn_domain}/assets/images/flags/es.svg`,
  },
  {
    value: 'de',
    label: 'Lygo:AdvancedMenu.video.Subtitles.Country.Germany.label',
    languageLabel: 'Deutsche',
    flag: `${config.cdn_domain}/assets/images/flags/de.svg`,
  },
  {
    value: 'ar',
    label: 'Lygo:AdvancedMenu.video.Subtitles.Country.Arab.label',
    languageLabel: 'اَلْعَرَبِيَّةُ',
    flag: `${config.cdn_domain}/assets/images/flags/sa.svg`,
  },
  {
    value: 'hi',
    label: 'Lygo:AdvancedMenu.video.Subtitles.Country.India.label',
    languageLabel: 'हिंदी',
    flag: `${config.cdn_domain}/assets/images/flags/in.svg`,
  },
  {
    value: 'pt',
    label: 'Lygo:AdvancedMenu.video.Subtitles.Country.Portugal.label',
    languageLabel: 'Português',
    flag: `${config.cdn_domain}/assets/images/flags/pt.svg`,
  },
  {
    value: 'jv',
    label: 'Lygo:AdvancedMenu.video.Subtitles.Country.Japan.label',
    languageLabel: '日本語',
    flag: `${config.cdn_domain}/assets/images/flags/jp.svg`,
  },
  {
    value: 'ko',
    label: 'Lygo:AdvancedMenu.video.Subtitles.Country.Korean.label',
    languageLabel: '한국어',
    flag: `${config.cdn_domain}/assets/images/flags/kr.svg`,
  },
  {
    value: 'fr',
    label: 'Lygo:AdvancedMenu.video.Subtitles.Country.France.label',
    languageLabel: 'français',
    flag: `${config.cdn_domain}/assets/images/flags/fr.svg`,
  },
];

export const allowedFileExtension = '.vtt';
